import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FilterResultService {
  public isVisible: boolean = false;
  public filterValue: string = '';
  private filterButtonPressedSource = new Subject<string>();
  filterButtonPressed$ = this.filterButtonPressedSource.asObservable();
  
  constructor() { }

  toggleFilter(){
    this.isVisible = !this.isVisible;
  }

 
  notifyFilterButtonPressed(value: string) {
    this.filterValue = value;
    this.filterButtonPressedSource.next(value);
  }
}
